export function setTelemetryUser(id: string, email: string) {
  // noop
}
